import PropTypes from "prop-types";
import classNames from "classnames";
import "./radio.scss";
import IconRadioChecked from "app/pages/.shared/static/icons/IconRadioChecked";
import IconRadioUnchecked from "app/pages/.shared/static/icons/IconRadioUnchecked";
import { useField } from "formik";

const RadioFormik = ({
	children,
	showIcon = false,
	id,
	body,
	disabled,
	toggle = () => {},
	checked = {},
	className,
	...props
}) => {
	const [field, meta] = useField({ ...props, type: "radio" });

	const onChange = () => {
		toggle();
	};

	const fieldChecked = checked?.shouldCheckTheValue ? checked.value : field.checked;

	const radioClassName = classNames({
		radio: true,
		[className]: true,
		"radio--checked": fieldChecked,
		"radio--error": meta.touched && meta.error,
		"radio--disabled": disabled,
	});

	const iconNode = showIcon ? (
		<div className="radio__icon">
			{fieldChecked ? (
				<IconRadioChecked width={15} height={15} />
			) : (
				<IconRadioUnchecked width={15} height={15} />
			)}
		</div>
	) : (
		false
	);

	const bodyNode = body ? <div className="radio__content">{body}</div> : false;

	return (
		<div className={radioClassName} data-testid={props["data-testid"]}>
			<input className="radio__input" id={id} {...field} onClick={onChange} type="radio" />
			<label className="radio__label" htmlFor={id}>
				<div className="radio__header">
					{iconNode}
					<div className="radio__text">{children}</div>
				</div>
				{bodyNode}
			</label>
		</div>
	);
};

RadioFormik.propTypes = {
	disabled: PropTypes.bool,
	showIcon: PropTypes.bool,
	name: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	id: PropTypes.string,
	toggle: PropTypes.func,
	body: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.bool]),
	field: PropTypes.object,
	className: PropTypes.string,
	"data-testid": PropTypes.string,
	checked: PropTypes.object,
};

export default RadioFormik;
